import { useNavigate } from "react-router";

import { ChevronRight } from "components/icons/generated";
import Box from "ds/components/Box";
import IconEmphasized from "ds/components/IconEmphasized";
import { IconEmphasizedColor } from "ds/components/IconEmphasized/types";
import TileContent from "ds/components/Tile/Content";
import TileIndicator from "ds/components/Tile/Indicator";
import TileTitle from "ds/components/Tile/Title";
import TileWrapper from "ds/components/Tile/Wrapper";
import { IconComponent } from "types/Icon";
import Icon from "ds/components/Icon";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageLaunchpad } from "hooks/useAnalytics/pages/launchpad";

export type LaunchPadExploreNextItemProps = {
  title: string;
  icon: IconComponent;
  to: string;
  iconColor: IconEmphasizedColor;
  analyticsTitle: string;
};

const LaunchPadExploreNextItem = ({
  title,
  icon,
  to,
  iconColor,
  analyticsTitle,
}: LaunchPadExploreNextItemProps) => {
  const navigate = useNavigate();
  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageLaunchpad.Launchpad,
  });

  const handleClick = () => {
    trackSegmentAnalyticsEvent(analyticsTitle);
    navigate(to);
  };

  return (
    <TileWrapper onClick={handleClick}>
      <Box justify="between" grow="1">
        <TileContent direction="column">
          <IconEmphasized icon={icon} color={iconColor} />
          <TileTitle>{title}</TileTitle>
        </TileContent>
        <TileIndicator indicator={<Icon src={ChevronRight} />} />
      </Box>
    </TileWrapper>
  );
};

export default LaunchPadExploreNextItem;
